import { CLEAR_ALL, LOGOUT } from '../../../../store/Types';

export const ALL_PAGOS_SUSCRIPCION = 'ALL_PAGOS_SUSCRIPCION';
export const LOADING_ALL_PAGOS_SUSCRIPCION = 'LOADING_ALL_PAGOS_SUSCRIPCION';
export const ACTIVO_PAGOS_SUSCRIPCION = 'ACTIVO_PAGOS_SUSCRIPCION';
export const ALERT_VIEW_PAGOS_SUSCRIPCION = 'ALERT_VIEW_PAGOS_SUSCRIPCION';
export const ALERT_FORM_PAGOS_SUSCRIPCION = 'ALERT_FORM_PAGOS_SUSCRIPCION';
export const PARAMS_PAGOS_SUSCRIPCION = 'PARAMS_PAGOS_SUSCRIPCION';
export const SEARCH_PAGOS_SUSCRIPCION = 'SEARCH_PAGOS_SUSCRIPCION';

const initialState = {
  all: [],
  loadingAll: false,
  search: [],
  activo: null,
  params: {},
  alertView: null,
  alertForm: null,
};

export const pagosSuscripcionReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_PAGOS_SUSCRIPCION:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_PAGOS_SUSCRIPCION:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_PAGOS_SUSCRIPCION:
      return {
        ...state,
        activo: action.payload,
      };
    case ALERT_VIEW_PAGOS_SUSCRIPCION:
      return {
        ...state,
        alertView: action.payload,
      };
    case ALERT_FORM_PAGOS_SUSCRIPCION:
      return {
        ...state,
        alertForm: action.payload,
      };
    case SEARCH_PAGOS_SUSCRIPCION:
      return {
        ...state,
        search: action.payload,
      };
    case PARAMS_PAGOS_SUSCRIPCION:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
